import {withBreadcrumbs} from "../../common/hoc/Breadcrumbs";
import {field} from "../../generic/tables";
import TableCard from "../../generic/cards/TableCard";
import DataTable from "../../generic/tables/DataTable";
import {useDefaultEndpoints} from "../../../lib/api/useDefaultEndpoints";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {datetime} from "../../../lib/utils/format";
import {Button, FormGroup, Input, InputGroup, InputGroupAddon, Label} from "reactstrap";
import {FaSearch} from "react-icons/all";
import {RangedDatePicker} from "../../generic/fields";
import {FaTimes} from "react-icons/fa";
import {t} from "i18next";

const InsuranceMonitoring = withBreadcrumbs((props) => {
    const {findAndCountEntries} = useDefaultEndpoints('orders-insurances');
    const history = useHistory();

    const [fioFilter, setFioFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [responseStatusFilter, setResponseStatusFilter] = useState('');
    const [daysFilter, setDaysFilter] = useState({
        from: undefined,
        to: undefined,
    });

    const filters = {
        _where: {
            _and: [
                ...(fioFilter ? [{ 'client_id.full_name_search_contains': fioFilter }] : []),
                ...(statusFilter ? [{ 'status': statusFilter }] : []),
                ...(responseStatusFilter ? [{ 'response_status': responseStatusFilter }] : []),
                ...(daysFilter.from || daysFilter.to ? [{
                    ...(daysFilter.from ? { created_at_gte: new Date(daysFilter.from).toISOString() } : {}),
                    ...(daysFilter.to ? { created_at_lte: new Date(daysFilter.to).toISOString() } : {})
                }] : [])
            ]
        }
    };

    const resetFilters = () => {
        setFioFilter('');
        setStatusFilter('');
        setResponseStatusFilter('');
        setDaysFilter({ from: undefined, to: undefined });
        setResponseStatusFilter('');
    }

    const isActiveFilters = fioFilter || statusFilter || daysFilter.from || daysFilter.to;

    const getFullName = (client) => {
        if (!client) return null;

        const fullNameArr = [client?.last_name, client?.first_name, client?.surname].filter(Boolean);
        return fullNameArr.length ? fullNameArr.join(' ') : null;
    }

    const fields = [
        field(t('monitoring.insuranceMonitoring.fio'), true, 'client_id.full_name_search', res => (
            getFullName(res.client_id) || '—'
        )),
        field(t('monitoring.insuranceMonitoring.orderId'), true, 'order_id.id', res => (
            <span
                className="text-primary"
                style={{cursor: 'pointer'}}
                onClick={e => {
                    e.stopPropagation();
                    if (res.order_id?.id) history.push(`/administration/orders/edit/${res.order_id.id}`);
                }}
            >
                {res.order_id?.id || '—'}
            </span>
        )),
        field(t('monitoring.insuranceMonitoring.insuranceId'), true, "insurance_id"),
        field(t('monitoring.insuranceMonitoring.startDate'), true, "created_at", res => (
            datetime(res.created_at)
        )),
        field(t('monitoring.insuranceMonitoring.insuranceStatus'), true, "insurance_status", res => (
            res.status || '—'
        )),
        field(t('monitoring.insuranceMonitoring.insuranceDetail'), true, "insurance_detail", res => (
            res.message || '—'
        )),
    ];

    return (
        <TableCard>
            <div className="row">
                <div className="col-12 col-md-3">
                    <FormGroup>
                        <Label className="text-muted">{t('monitoring.insuranceMonitoring.searchFio')}</Label>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <span className="input-group-text">
                                    <FaSearch/>
                                </span>
                            </InputGroupAddon>
                            <Input
                                type="text"
                                placeholder={t('monitoring.insuranceMonitoring.enterFio')}
                                value={fioFilter}
                                onChange={e => setFioFilter(e.target.value)}
                            />
                        </InputGroup>
                    </FormGroup>
                </div>

                <div className="col-12 col-md-3">
                    <FormGroup>
                        <Label className="text-muted">{t('monitoring.insuranceMonitoring.insuranceStatus')}</Label>
                        <Input
                            type="select"
                            value={statusFilter}
                            onChange={e => setStatusFilter(e.target.value)}
                        >
                            <option value="">{t('monitoring.insuranceMonitoring.statuses.all')}</option>
                            <option value="success">{t('monitoring.insuranceMonitoring.statuses.created')}</option>
                            <option value="error">{t('monitoring.insuranceMonitoring.statuses.withError')}</option>
                        </Input>
                    </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                    <FormGroup>
                        <Label className="text-muted">{t('monitoring.insuranceMonitoring.endDate')}</Label>
                        <RangedDatePicker daysFilter={daysFilter} setDaysFilter={setDaysFilter} size={'md'}/>
                    </FormGroup>
                </div>
            </div>
            {isActiveFilters &&
                <div className="row mb-4">
                    <div className="col-12">
                        <Button
                            color={'primary'}
                            onClick={resetFilters}
                            className="btn-sm btn-rounded"
                        >
                            <FaTimes className={'mr-1'}/>
                            {t('monitoring.insuranceMonitoring.resetFilters')}
                        </Button>
                    </div>
                </div>
            }
            <DataTable
                findAndCount={findAndCountEntries}
                filters={filters}
                fields={fields}
                sortField="created_at"
                sortDir="desc"
                name="insurance-orders-list"
            />
        </TableCard>
    )
})

export default InsuranceMonitoring;